var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6C13.4512 6 12.4453 6.42143 11.7037 7.17157C10.9621 7.92172 10.5455 8.93913 10.5455 10C10.5455 11.0609 10.9621 12.0783 11.7037 12.8284C12.4453 13.5786 13.4512 14 14.5 14C15.5488 14 16.5547 13.5786 17.2963 12.8284C18.0379 12.0783 18.4545 11.0609 18.4545 10C18.4545 8.93913 18.0379 7.92172 17.2963 7.17157C16.5547 6.42143 15.5488 6 14.5 6ZM14.5 16.6667C12.752 16.6667 11.0756 15.9643 9.83952 14.714C8.60349 13.4638 7.90909 11.7681 7.90909 10C7.90909 8.23189 8.60349 6.5362 9.83952 5.28595C11.0756 4.03571 12.752 3.33333 14.5 3.33333C16.248 3.33333 17.9244 4.03571 19.1605 5.28595C20.3965 6.5362 21.0909 8.23189 21.0909 10C21.0909 11.7681 20.3965 13.4638 19.1605 14.714C17.9244 15.9643 16.248 16.6667 14.5 16.6667ZM14.5 0C7.90909 0 2.28045 4.14667 0 10C2.28045 15.8533 7.90909 20 14.5 20C21.0909 20 26.7195 15.8533 29 10C26.7195 4.14667 21.0909 0 14.5 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.fe6b03af10941ae75f510ccb20d9cfef.svg";
export { ForwardRef as ReactComponent };